<template>
  <div v-if="toolVisible">
    <div class="tslsClass onePictureDialog dy3dDialog">
      <div class="headerClass">
        <div class="headerTitle">
          <!-- <img  :src="require('@/assets/images/dlgTitle.png')"/> -->
          <span>图上量算</span>
        </div>

        <div class="boxClose">
          <img
            :src="require('@/assets/images/poscloseIcon.png')"
            style="cursor: pointer"
            @click="toolsClose()"
          />
        </div>
        <!-- <span @click="close()"><a-icon type="close" style="color: aliceblue;cursor: pointer;" /></span> -->
      </div>
      <img class="splitLine" :src="require('@/assets/images/splitlineIcon.png')"/>
      <div class="areaTools">
        <div style="margin-bottom: 2%">
          <span>操作：</span>
          <a-button class="delBtn" @click="removeAll"
            >清除测量数据</a-button
          >
        </div>
        <div style="margin-bottom: 2%">
          <span>单位：</span>
          <a-select
            :default-value="unit"
            style="width: 128px"
            @change="handleChange"
          >
            <a-select-option value="auto"> 自动 </a-select-option>
            <a-select-option value="m"> 米 </a-select-option>
            <a-select-option value="km"> 公里 </a-select-option>
            <a-select-option value="mile"> 海里 </a-select-option>
            <a-select-option value="zhang"> 仗 </a-select-option>
          </a-select>
        </div>
        <div style="margin-bottom: 2%;">
          <a-checkbox
            :checked="onlyPickModelPosition"
            @click="checkOnlyPickModelPosition"
            style="color: rgba(255, 255, 255, 0.5); font-size: 14px"
            >仅测量模型（不拾取地形）</a-checkbox
          >
        </div>
        <div style="margin-bottom: 2%;">
          <a-checkbox
            :checked="onlyVertexPosition"
            @click="checkOnlyVertexPosition"
            style="color: rgba(255, 255, 255, 0.5); font-size: 14px"
            >开启顶点吸附</a-checkbox
          >
        </div>
        <div class="rowBtn">
          <a-row style="margin-bottom: 2%">
            <a-button class="toolBtn" type="primary" @click="measureLength">空间距离</a-button>
            <a-button class="toolBtn" type="primary" @click="measureSurfaceLength">贴地距离</a-button>
            <a-button class="toolBtn" type="primary" @click="measureSection" id="measureStep_1">剖面</a-button>
          </a-row>
          <a-row style="margin-bottom: 2%">
            <a-button class="toolBtn" type="primary" @click="measureArea">水平面积</a-button>
            <a-button class="toolBtn" type="primary" @click="measureSurfaceeArea">贴地面积</a-button>
            <a-button class="toolBtn" type="primary" @click="measureAngle">角度</a-button>
          </a-row>
          <a-row>
            <a-button class="toolBtn" type="primary" @click="measureTriangleHeight">三角测量</a-button>
            <a-button class="toolBtn" type="primary" @click="measurePoint">坐标测量</a-button>
            <a-button class="toolBtn" type="primary" @click="measureHeight">高度差</a-button>
          </a-row>
        </div>
      </div>
    </div>
  </div>
  <!-- <a-drawer
    title="图上量算"
    placement="right"
    :width="310"
    :closable="true"
    :mask="false"
    :visible="toolVisible"
    :get-container="false"
    @close="toolsClose"
    ref="measureTool"
    class="earth-tree-ct1"
  >
    <a-row type="flex" class="row">
      <a-col :span="8">
        <a-avatar @click="measureLength" :size="64" style="background-color: #dd751b; cursor: pointer">
          空间距离</a-avatar
        >
      </a-col>
      <a-col :span="8">
        <a-avatar @click="measureSurfaceLength" :size="64" style="background-color: #c092fe; cursor: pointer">
          贴地距离</a-avatar
        >
      </a-col>
      <a-col :span="8">
        <a-avatar @click="measureSection" :size="64" style="background-color: #88b8ff; cursor: pointer"> 剖面</a-avatar>
      </a-col>
    </a-row>
    <a-row type="flex" class="row">
      <a-col :span="8">
        <a-avatar @click="measureArea" :size="64" style="background-color: #dd751b; cursor: pointer">
          水平面积</a-avatar
        >
      </a-col>
      <a-col :span="8">
        <a-avatar @click="measureSurfaceeArea" :size="64" style="background-color: #c092fe; cursor: pointer">
          贴地面积</a-avatar
        >
      </a-col>
      <a-col :span="8">
        <a-avatar @click="measureAngle" :size="64" style="background-color: #88b8ff; cursor: pointer"> 角度</a-avatar>
      </a-col>
    </a-row>
    <a-row type="flex" class="row">
      <a-col :span="8">
        <a-avatar @click="measureTriangleHeight" :size="64" style="background-color: #dd751b; cursor: pointer">
          三角测量</a-avatar
        >
      </a-col>
      <a-col :span="8">
        <a-avatar @click="measurePoint" :size="64" style="background-color: #c092fe; cursor: pointer">
          坐标测量</a-avatar
        >
      </a-col>
      <a-col :span="8">
        <a-avatar @click="measureHeight" :size="64" style="background-color: #88b8ff; cursor: pointer">
          高度差</a-avatar
        >
      </a-col>
    </a-row>
    <a-row type="flex" justify="center" class="row">
      <a-col>
        <a-checkbox :checked="onlyPickModelPosition" @click="checkOnlyPickModelPosition" style="color: #ffffff"
          >仅测量模型（不拾取地形）</a-checkbox
        >
      </a-col>
    </a-row>
    <a-row type="flex" justify="center" class="row fontcolor">
      <a-col>
        <span>单位</span>
        <a-select :default-value="unit" style="width: 120px" @change="handleChange">
          <a-select-option value="auto"> 自动 </a-select-option>
          <a-select-option value="m"> 米 </a-select-option>
          <a-select-option value="km"> 公里 </a-select-option>
          <a-select-option value="mile"> 海里 </a-select-option>
          <a-select-option value="zhang"> 仗 </a-select-option>
        </a-select>
      </a-col>
    </a-row>
    <a-row type="flex" justify="center" class="row">
      <a-col>
        <a-button type="primary" @click="removeAll">清除测量数据</a-button>
      </a-col>
    </a-row>
  </a-drawer> -->
</template>

<script>
import { reduce } from "lodash";

let measure = null;
let map;
let eventTarget;
export default {
  name: "MeasureTools",
  data() {
    return {
      toolVisible: false,
      onlyPickModelPosition: false,
      onlyVertexPosition:false, // 开启顶点吸附
      escCount: 0,
      unit: "auto",
    };
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    //监听键盘事件
    handleKeydown(event) {
      if (event.keyCode === 27) {
        this.escCount++;
        if (this.toolVisible) {
          this.removeAll();
        }
      }
    },
    init(cmap) {
      map = cmap;
      let that = this;
      eventTarget = new mars3d.BaseClass();
      // console.log('eventTarget', eventTarget)
      eventTarget.on("measureEnd", (event) => {
        // console.log('measureEnd66666666', event)
        that.$parent.setEchartsData(event);
      });
      eventTarget.on("measureClick", (event) => {
        console.log("measureClick5555555", event, that);
        // that.$parent('setEchartsData', event.value)
        that.$parent.setEchartsData(event.value);
      });
    },
    //单位选择事件
    handleChange(e) {
      this.unit = e;
      console.log("handleChange", e, this.unit);
    },
    checkOnlyPickModelPosition() {
      this.onlyPickModelPosition = !this.onlyPickModelPosition;
    },
    checkOnlyVertexPosition(val){
      console.log('val',val,this.onlyVertexPosition);
      this.onlyVertexPosition = !this.onlyVertexPosition
      map.onlyVertexPosition = this.onlyVertexPosition
    },
    toolsClose() {
      this.removeAll();
      this.toolVisible = false;
    },
    handleMenuClick(e) {
      console.log("handleMenuClick", e);
    },
    addMeasure(cmap) {
      let that = this;
      if (measure != null) {
        console.log("measure已经初始化过！", measure);
        return;
      }
      map = cmap;
      measure = new mars3d.thing.Measure({
        label: {
          color: "#ffffff",
          font_family: "楷体",
          font_size: 20,
          background: false,
        },
      });
      // Vue.prototype.measure = measure
      map.addThing(measure);
      // 添加事件
      measure.on(mars3d.EventType.start, function (e) {
        // console.log('开始异步分析', e)
      });
      measure.on(mars3d.EventType.end, function (e) {
        // console.log('完成异步分析', e)
        if (e.graphic.type === mars3d.graphic.SectionMeasure.type) {
          eventTarget.fire("measureEnd", e);
          // eventTarget.fire('click', { value: e.graphic.measured })
        }
      });

      measure.on(mars3d.EventType.click, function (e) {
        // console.log('单击了对象', e, that.mars3d, eventTarget)
        that.$emit("hideTipMarker");

        if (e.graphic.type === mars3d.graphic.SectionMeasure.type) {
          // console.log('单击了对象给我更新了eventTarget.fire', that.mars3d.graphic.SectionMeasure.type, e.graphic.type)
          console.log("eventTarget", eventTarget);
          eventTarget.fire("measureClick", { value: e.graphic.measured });
          // eventTarget.fire('click', { value: e.graphic.measured })
        }
      });
    },
    // 水平面积
    measureArea() {
      this.escCount = 0;
      measure.area({
        style: {
          color: "#00fff2",
          opacity: 0.4,
          outline: true,
          outlineColor: "#fafa5a",
          outlineWidth: 1,
          clampToGround: false, //贴地
        },
      });
    },
    // 贴地距离
    measureSurfaceLength() {
      this.escCount = 0;
      console.log("measureSurfaceLength", measure);
      measure.distanceSurface({
        showAddText: true,
        unit: this.unit, //支持传入指定计量单位
        style: {
          color: "#ffff00",
          width: 3,
          clampToGround: true, //是否贴地
        },
      });
    },
    //空间距离
    measureLength() {
      this.escCount = 0;
      // measure.distance()
      measure.distance({
        showAddText: true,
        unit: this.unit,
        style: {
          label: {
            // 自定义显示label的graphic类型
            type: "div",
            font_size: 60,
            color: "#dd751b",
            backgroundColor: "#fff",
            updateText: function (text, graphic) {
              // updateText是必须，用于动态更新 text
              graphic.html = `<div class="marsGreenGradientPnl" >${text}</div>`;
            },
            // 下面是graphic对应类型本身的参数
            html: `<div class="marsGreenGradientPnl" ></div>`,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          },
        },
      });
    },
    // 贴地面积
    measureSurfaceeArea() {
      this.escCount = 0;
      measure.areaSurface({
        style: {
          color: "#ffff00",
        },
        splitNum: 10, // step插值分割的个数
      });
    },
    // 高度差
    measureHeight() {
      this.escCount = 0;
      measure.height();
    },

    // 三角测量
    measureTriangleHeight() {
      this.escCount = 0;
      measure.heightTriangle();
    },

    // 方位角
    measureAngle() {
      this.escCount = 0;
      measure.angle();
    },

    // 坐标测量
    measurePoint() {
      this.escCount = 0;
      measure.point();
    },
    measureSection() {
      this.escCount = 0;
      measure.section({
        splitNum: 300, // 插值次数
      });
    },
    measureAngle() {
      this.escCount = 0;
      measure.angle();
    },
    removeAll() {
      if (measure) {
        measure.clear();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tslsClass {
  position: absolute;
  top: 45px;
  width: 500px;
  max-width: 500px;
  height: 670px;
  right: 10px;
  // padding: 0px 15px;
  border-radius: 4px;
  color: #ffffff;
  box-shadow: 0 3px 14px rgba(128, 128, 128, 0.5);
  backdrop-filter: blur(15px);
  z-index: 999;
  .headerClass {
    position: relative;
  }
}
.areaTools {
  margin: 0 3%;
  & > div:not(.rowBtn) {
    display: flex;
    align-items: center;
  }
  span {
    font-size: 14px;
  }
  .toolBtn {
    width: 90px;
    border-color: transparent;
    font-size: 14px;
    margin-right: 10px;
    // box-shadow: inset 0px 0px 10px 0px #1661F6;
  }
  .delBtn {
    background: rgba(255, 90, 90, 0.2);
    color: #ff5a5a;
  }

  /deep/ .ant-divider-horizontal {
    //   margin: 8% 2% !important;
    width: 96%;
    min-width: 97%;
  }

  /deep/ .ant-divider {
    background: rgba(255, 255, 255, 0.1);
  }
}
.rowBtn {
  background: rgba(255, 255, 255, 0.2);
  padding: 2%;
  /deep/ .ant-row {
    display: flex;
    justify-content: space-around;
  }
}
.row {
  margin-bottom: 30px;
  color: #fff;
}
.earth-tree-ct1 {
  /deep/.ant-drawer {
    top: 135px;
    height: calc(100% - 90px);
  }
}
.earth-details-popup {
  z-index: 1;
}
.fontcolor {
  color: #ffffff;
}

/**************** 一个简洁文本面板,中间竖直连线 ****************/
.marsGreenGradientPnl {
  width: 100px;
  text-align: center;
  background-image: linear-gradient(to right, #565d39, #00ffc3);
  position: absolute;
  left: -56px;
  bottom: 28px;
  cursor: default;
  padding: 5px;
  border: 1px solid #9c9944e8;
}

.marsGreenGradientPnl:hover {
  border: 1px solid rgb(9, 255, 0);
}

.marsGreenGradientPnl::before {
  position: absolute;
  content: "";
  left: 50%;
  bottom: -30px;
  height: 30px;
  border-left: 2px dashed #c5e22770;
}

.marsGreenGradientPnl-highlight {
  border: 2px solid yellow;
}

.marsGreenGradientPnl-highlight::before {
  border-left: 2px dashed yellow !important;
}

/deep/ .ant-btn-primary {
  border-color: transparent;
}

/deep/ .ant-select-selection {
  background-color: rgba(255, 255, 255, 0.2);
  border: 0px solid #ffffff;
}
/deep/ .ant-checkbox-inner {
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/deep/.ant-select-selection__rendered {
  margin-left: 17px;
}
</style>